import { _api } from '@shared/msp/api.js';
import { getConfig } from '@shared/config/runtime.js';

function getEndpoint() {
    return getConfig().api_base_url + "/api/v2/messaggio.php";
}

const chatTypes = {
"calendario": {
    "endpoint": "chat_calendario",
    "key": "calendario_id"
},
    "one_on_one": {
        "endpoint": "chat_one_on_one",
        "key": "utente_id",
    }
};
const htmlDecode = function (input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

const messaggi = {
    makeExcerpt: function (text) {
        if (!(text && text.length)) return "";
        let excerpt = text.replace(/<\/?[^>]+(>|$)/g, "");
        excerpt = htmlDecode(excerpt);
        return excerpt;
    },
    postMessageUpdateFeeds: function () {
        let message = {
            action: 'updateFeeds',
            data: null,
        };
        window && window.postMessage(message);
        window.opener && window.opener.postMessage(message);
    },
    setLetti: async function (a_ids = []) {
        let ids = a_ids.join(",");
        let url = getEndpoint()+"?letto&ids="+ids;
        let result = await _api(url, "PUT", null);
        if (!result.success) return false;
        return result.data.updated;
    },
    send: async function (chatId, text) {
        const url = getEndpoint()+"?chat_id="+chatId
        const data = {
            "testo": text,
        };
        const result = await _api(url, "POST", data);
        return result;
    },
    loadMessages: async function (chatId) {
        const url = getEndpoint()+"?chat_id="+chatId;
        const result = await _api(url, 'GET', null);
        return result;
    },
    getChatType: async function (chatId) {
        const url = getEndpoint()+"?type&chat_id="+chatId;
        const result = await _api(url, 'GET', null);
        return result;
    },

    loadCountSospesi: async function () {
        const url = getEndpoint()+"?count&sospesi";
        const result = await _api(url, 'GET', null);

        return result;
    },

    loadChatsOneOnOne: async function (type) {
        if (!type) type = "attivi";
        const params = (type==='sospesi')
            ? '?chats_one_on_one&sospesi'
            : '?chats_one_on_one';
        const url = getEndpoint()+params;
        const result = await _api(url, 'GET', null);

        return result;
    },
    loadChatsCalendario: async function ({page,limit}) {
        const url = getEndpoint()+`?commenti&page=${page}&limit=${limit}`;
        const result = await _api(url, 'GET', null);
        return result;
    },
    fails: function () {
        return Promise.resolve({success: false});
    },
    findChatType: function (nome) {
        if (!chatTypes[nome]) return null;
        return chatTypes[nome];
    },
    addChat: async function (type, id) {
        const chatType = messaggi.findChatType(type);
        if (!chatType) {
            return messaggi.fails();
        }
        let url = getEndpoint()+"?"+chatType.endpoint;
        let data = {
            [chatType.key]: id,
        };
        let result = await _api(url, "POST", data);
        if (!result.success) {
            return false;
        }
        return result.data;
    },
}
export default messaggi;
